import { PublicUrlsService } from '@getexpain/public-urls';

import { isDevelopment } from 'utils/EnvUtils';

import { publicUrlsEnvVars } from 'constants/config';

const publicUrlsInput = isDevelopment ? undefined : publicUrlsEnvVars;
export const publicUrlsService = new PublicUrlsService(isDevelopment, publicUrlsInput);
